module.exports = __webpack_public_path__ + "img/Q3.917b59f6.jpg";